// An app tab (Settings > Operator Dashboard > New Custom Tab > gallery pick) is persisted with the
// view's appId and no url. The rest of the tab pipeline keys on `url`, so the url is looked up
// here once, before the tabs reach the store. A tab whose view cannot be resolved is dropped for
// this load; the settings table still lists it for an admin to delete.
export const isAppTab = (tab) => {
  return Boolean(tab) && tab.appId != null && !tab.url;
};

const resolved = new Map();

export const clearResolvedAppTabs = () => {
  return resolved.clear();
};

const resolveOne = async (tab, fetchApp) => {
  const key = String(tab.appId);
  if (!resolved.has(key)) {
    resolved.set(
      key,
      fetchApp(tab.appId).catch((error) => {
        resolved.delete(key);
        // eslint-disable-next-line no-console
        console.warn(
          `app tab ${tab.id}: could not resolve appId ${key}`,
          error
        );
        return null;
      })
    );
  }
  const app = await resolved.get(key);
  if (!app || !app.url) {
    return null;
  }
  // Registered views are Carbide apps: always the embedded zone, never the manifest probe.
  return { ...tab, url: app.url, isEmbed: true };
};

export const resolveAppTabs = async (tabs, fetchApp) => {
  const out = await Promise.all(
    tabs.map((tab) => {
      return isAppTab(tab) ? resolveOne(tab, fetchApp) : tab;
    })
  );
  return out.filter(Boolean);
};

export default resolveAppTabs;
